module.exports = __webpack_public_path__ + "static/media/outer_fabric_cuff.23de0b69.svg";